import React from 'react';
import { PaginationButton } from 'elements/Pagination';
import { StyledNav } from './styled';

class PaginationNav extends React.PureComponent {
    render () {
        const {
          prev,
          next,
          teksti,
        } = this.props;
        
        if (prev || next) {

          const renderButton = (target, rel) => {
              return (
                <PaginationButton
                    rel={rel}
                    label={target.label}
                    title={target.label}
                    onClick={target.onClick}
                    path={target.path}
                    teksti={teksti}
                />
              );
          };

          // NOTE: <span /> nepieciešams, lai gadījumā, kad pogā 'Tālāk' ir vienīgā, tā atrastos labajā pusē (flex)
          const prevButton = prev ? renderButton(prev, 'prev') : <span />;
          const nextButton = next ? renderButton(next, 'next') : <span />;

          return (
            <StyledNav>
              {prevButton}
              {nextButton}
            </StyledNav>
          );
        }

        return null;
    }
}

export default PaginationNav;


// WEBPACK FOOTER //
// ./src/elements/Pagination/PaginationNav.jsx